define('DefaultFacetSelection.ShowOutOfStock.View'
,   [
		'defaultfacetselection_showoutofstock.tpl'
	,	'Backbone'
	,	'underscore'
	]
,   function(
		defaultfacetselection_showoutofstock_tpl
	,	Backbone
	,	_
	)
{
	'use strict';

	return Backbone.View.extend({
		template: defaultfacetselection_showoutofstock_tpl

	,	attributes: {
			class: 'defaultfacetselection-showoutofstock-container'
		}
		
	,	initialize: function(options){
			this.application = options.application;
			this.facetID = options.facetID;
			this.facetValue = options.facetValue;
			this.translator = options.translator;
			this.totalProducts = options.totalProducts;
			
			if(this.facetID){
				this.events = {
					['change [name="' + this.facetID + '"]']: 'setOutOfStockPreference'
				};
			}
		}
		/**
		 * Sets/unsets user input in the session storage and navigates the user to a PLP.
		 * @method setOutOfStockPreference
		 * @param {Event} e
		 */
	,	setOutOfStockPreference: _.debounce(function(e){
			var isChecked = !!e.currentTarget.checked
			,	currentPage = this.translator.getOptionValue('page')
			,	translator = this.translator.cloneWithoutFacetId(this.facetID);

			translator = !!currentPage && (currentPage !== 1) ? translator.cloneForOption('page', 1) : translator;

			isChecked
				? (sessionStorage || window.sessionStorage).setItem('showOutOfStockItems', isChecked)
				: (sessionStorage || window.sessionStorage).removeItem('showOutOfStockItems');

			Backbone.history.navigate(translator.getUrl(), {trigger: true});
		}, 300)
		
	,	getContext: function(){
			var currentFacetValue = this.translator.getFacetValue(this.facetID)
			,	isHideOfStockActive = !!(currentFacetValue == this.facetValue);

			return {
				facetID: this.facetID
			,	isActive: !(sessionStorage || window.sessionStorage).getItem('showOutOfStockItems') ? false : !isHideOfStockActive
			};
		}
	});
});
